<h3>{{ 'changePassword.requiredPasswordChange' | translate }}</h3>
<ng-container>
    <div class="content">
        <form action="" [formGroup]="requirePasswordChangeForm">
            <div class="inputLine">
                <label for="password">{{ 'users.onboarding.form.password' | translate }}</label>
                <app-form-error [parentForm]="requirePasswordChangeForm" [controlPath]="'password'" />
                <app-password-input [id]="'password'" formControlName="password" />
            </div>

            <div class="inputLine confirmPasswordContainer">
                <label for="confirmPassword">{{ 'users.onboarding.form.confirmPassword' | translate }}</label>
                <app-form-error [parentForm]="requirePasswordChangeForm" [controlPath]="'confirmPassword'" />
                <app-password-input [showHints]="false" [id]="'confirmPassword'" formControlName="confirmPassword" />
            </div>
        </form>

        <div class="buttonArea centeredButtons">
            <button class="button primary" (click)="changePassword()">{{ 'generalKeywords.changePassword' | translate }}</button>
        </div>
    </div>
</ng-container>
